import Clipboard from '@react-native-clipboard/clipboard';
import {flow, toString} from 'lodash/fp';

import {showCopiedToClipboardToast} from '/util/toast.util';

export const setStringToClipboard = (copiedString: any) => {
  Clipboard.setString(copiedString);
};

export const copyToClipboard = flow(
  toString,
  setStringToClipboard,
  showCopiedToClipboardToast,
);
